import React from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';

import _isEmpty from 'lodash/isEmpty';
import _cloneDeep from 'lodash/cloneDeep';

import * as FeatherIcon from 'react-feather';

import MenuItem from '../MenuItem';

const MenuItemWithChildren = ({ item, isSourceExplorer, linkClassNames, subMenuClassNames }) => {
    const [activatedMenuItemIds, setActivatedMenuItemIds] = React.useState([]);

    React.useEffect(() => {
        setActivatedMenuItemIds([]);
    }, [item]);

    return (
        <li
            className={classNames('side-nav-item', { 'active mm-active': activatedMenuItemIds.indexOf(item.id) >= 0 })}
            onClick={() => setActivatedMenuItemIds(_cloneDeep([item.id]))}
        >
            <Link
                to={
                    isSourceExplorer
                        ? {
                              pathname: '/',
                              search: `?query=${item.name}`,
                              state: item.name,
                          }
                        : '/'
                }
                className={classNames('side-sub-nav-link', linkClassNames)}
                aria-expanded={activatedMenuItemIds.indexOf(item.id) >= 0}
            >
                <FeatherIcon.Grid />
                {item.badge && <span className={`badge badge-${item.badge.variant} float-end`}>{item.badge.text}</span>}
                <span> {item.name} </span>
                <span className="menu-arrow" />
            </Link>

            <ul
                className={classNames(subMenuClassNames, {
                    'mm-collapse mm-show': activatedMenuItemIds.indexOf(item.id) >= 0,
                })}
                aria-expanded={activatedMenuItemIds.indexOf(item.id) >= 0}
            >
                {item.children.map((child, i) => {
                    return (
                        <React.Fragment key={i}>
                            {child.children ? (
                                <MenuItemWithChildren
                                    item={child}
                                    linkClassNames={classNames({ active: activatedMenuItemIds.indexOf(child.id) >= 0 })}
                                    activatedMenuItemIds={activatedMenuItemIds}
                                    subMenuClassNames="side-nav-third-level"
                                />
                            ) : (
                                <MenuItem
                                    item={child}
                                    className={classNames({ active: activatedMenuItemIds.indexOf(child.id) >= 0 })}
                                    linkClassName={classNames({ active: activatedMenuItemIds.indexOf(child.id) >= 0 })}
                                />
                            )}
                        </React.Fragment>
                    );
                })}
            </ul>
        </li>
    );
};

export default React.memo(MenuItemWithChildren);
